import { UserRole } from '../constants';
const { Patient: patient, Doctor: doctor } = UserRole;
export const locales = {
    af: { fileName: 'af', [patient]: true },
    ak: { fileName: 'ak', [patient]: true },
    am: { fileName: 'am', [patient]: true },
    ar: { fileName: 'ar', [doctor]: true, [patient]: true },
    az: { fileName: 'az', [patient]: true },
    be: { fileName: 'be', [patient]: true },
    bg: { fileName: 'bg', [patient]: true },
    bn: { fileName: 'bn', [patient]: true },
    bo: { fileName: 'bo', [patient]: true },
    'bs-BA': { fileName: 'bs_BA', [patient]: true },
    ca: { fileName: 'ca', [patient]: true },
    ceb: { fileName: 'ceb', [patient]: true },
    ch: { fileName: 'ch', [patient]: true },
    cs: { fileName: 'cs', [patient]: true },
    'cy-GB': { fileName: 'cy_GB', [patient]: true },
    da: { fileName: 'da', [patient]: true },
    de: { fileName: 'de', [doctor]: true, [patient]: true },
    el: { fileName: 'el', [doctor]: true, [patient]: true },
    en: { fileName: 'en', [doctor]: true, [patient]: true },
    'en-test': { fileName: 'en-test', [doctor]: true, [patient]: true },
    es: { fileName: 'es', [doctor]: true, [patient]: true },
    et: { fileName: 'et', [patient]: true },
    'eu-ES': { fileName: 'eu_ES', [patient]: true },
    fa: { fileName: 'fa', [patient]: true },
    fi: { fileName: 'fi', [doctor]: true, [patient]: true },
    fil: { fileName: 'fil', [patient]: true },
    fj: { fileName: 'fj', [patient]: true },
    'fo-FO': { fileName: 'fo_FO', [patient]: true },
    fr: { fileName: 'fr', [doctor]: true, [patient]: true },
    'fr-GA': { fileName: 'fr_GA', [doctor]: true, [patient]: true },
    'ga-IE': { fileName: 'ga_IE', [patient]: true },
    gd: { fileName: 'gd', [patient]: true },
    'gl-ES': { fileName: 'gl_ES', [patient]: true },
    gsw: { fileName: 'gsw', [patient]: true },
    'gu-IN': { fileName: 'gu_IN', [patient]: true },
    guz: { fileName: 'guz', [patient]: true },
    ha: { fileName: 'ha', [patient]: true },
    haw: { fileName: 'haw', [patient]: true },
    he: { fileName: 'he', [patient]: true },
    hi: { fileName: 'hi', [doctor]: true, [patient]: true },
    hr: { fileName: 'hr', [doctor]: true, [patient]: true },
    'ht-HT': { fileName: 'ht_HT', [patient]: true },
    hu: { fileName: 'hu', [patient]: true },
    hy: { fileName: 'hy', [patient]: true },
    id: { fileName: 'id', [patient]: true },
    ig: { fileName: 'ig', [patient]: true },
    is: { fileName: 'is', [patient]: true },
    it: { fileName: 'it', [doctor]: true, [patient]: true },
    ja: { fileName: 'ja', [doctor]: true, [patient]: true },
    jv: { fileName: 'jv', [patient]: true },
    'ka-GE': { fileName: 'ka_GE', [patient]: true },
    ki: { fileName: 'ki', [patient]: true },
    kk: { fileName: 'kk', [patient]: true },
    'km-KH': { fileName: 'km_KH', [patient]: true },
    'kn-IN': { fileName: 'kn_IN', [patient]: true },
    ko: { fileName: 'ko', [patient]: true, [doctor]: true },
    lb: { fileName: 'lb', [patient]: true },
    lo: { fileName: 'lo', [patient]: true },
    lt: { fileName: 'lt', [patient]: true },
    luo: { fileName: 'luo', [patient]: true },
    lv: { fileName: 'lv', [patient]: true },
    'mi-NZ': { fileName: 'mi_NZ', [patient]: true },
    'mk-MK': { fileName: 'mk_MK', [patient]: true },
    'ml-IN': { fileName: 'ml_IN', [patient]: true },
    'mn-MN': { fileName: 'mn_MN', [patient]: true },
    mr: { fileName: 'mr', [patient]: true },
    ms: { fileName: 'ms', [patient]: true },
    'mt-MT': { fileName: 'mt_MT', [patient]: true },
    my: { fileName: 'my', [patient]: true },
    ne: { fileName: 'ne', [patient]: true },
    nl: { fileName: 'nl', [patient]: true, [doctor]: true },
    no: { fileName: 'no', [patient]: true },
    nus: { fileName: 'nus', [patient]: true },
    'or-IN': { fileName: 'or_IN', [patient]: true },
    pa: { fileName: 'pa', [patient]: true },
    pl: { fileName: 'pl', [patient]: true },
    'ps-AF': { fileName: 'ps_AF', [patient]: true },
    pt: { fileName: 'pt', [doctor]: true, [patient]: true },
    ro: { fileName: 'ro', [doctor]: true, [patient]: true },
    ru: { fileName: 'ru', [doctor]: true, [patient]: true },
    sd: { fileName: 'sd', [patient]: true },
    si: { fileName: 'si', [patient]: true },
    sk: { fileName: 'sk', [patient]: true },
    sl: { fileName: 'sl', [patient]: true },
    so: { fileName: 'so', [patient]: true },
    sq: { fileName: 'sq', [patient]: true },
    sr: { fileName: 'sr', [patient]: true },
    su: { fileName: 'su', [patient]: true },
    sv: { fileName: 'sv', [doctor]: true, [patient]: true },
    sw: { fileName: 'sw', [patient]: true },
    ta: { fileName: 'ta', [patient]: true },
    'te-IN': { fileName: 'te_IN', [patient]: true },
    th: { fileName: 'th', [patient]: true },
    ti: { fileName: 'ti', [patient]: true },
    tl: { fileName: 'tl', [patient]: true },
    to: { fileName: 'to', [patient]: true },
    tr: { fileName: 'tr', [patient]: true },
    uk: { fileName: 'uk', [patient]: true },
    ur: { fileName: 'ur', [doctor]: true, [patient]: true },
    uz: { fileName: 'uz', [patient]: true },
    vi: { fileName: 'vi', [doctor]: true, [patient]: true },
    xh: { fileName: 'xh', [patient]: true },
    yo: { fileName: 'yo', [patient]: true },
    'zh-CN': { fileName: 'zh_CN', [doctor]: true, [patient]: true },
    'zh-TW': { fileName: 'zh_TW', [doctor]: true, [patient]: true },
    zu: { fileName: 'zu', [patient]: true },
};
